<template>
  <div class="flex flex-col justify-center">
    <div v-show="!finish">
      <yan-progress
        class="absolute bottom-0 rounded-none"
        :total="100"
        :done="progress"
      />

      <tiny-slider
        ref="assessmentSlider"
        axis="vertical"
        class="mt-2 md:mt-8"
        :controls="false"
        :loop="false"
        :rewind="false"
        :touch="false"
        :mouseDrag="false"
      >
        <div
          v-for="assessment in assessments"
          :key="assessment.index"
          :loop="false"
          class="px-8"
        >
          <p class="text-gray-700 text-xl text-center mb-8 w-full w-96">
            {{ assessment.index }}. {{ assessment.question }}
          </p>

          <div class="flex flex-col items-center px-8">
            <button
              v-for="choice in choices"
              :key="choice.name"
              @click="next(assessment, choice)"
              class="answer-button w-full md:w-96 py-4 text-gray-700 text-base"
            >
              {{ choice.name }}
            </button>

            <button
              @click="back"
              class="w-full md:w-96 py-1 mb-2 text-primary outline-none"
            >
              ย้อนกลับ
            </button>
          </div>
        </div>
      </tiny-slider>

      <div
        class="hidden md:flex flex-col md:flex-row justify-center items-center md:w-256 md:mt-12 mx-auto"
      >
        <img src="@/assets/cmu-logo.png" alt class="w-16 h-16 mb-8 md:mx-16" />

        <img
          src="@/assets/healthy-university-logo.jpg"
          class="w-24 h-24 mb-12 md:mx-16"
        />

        <img src="@/assets/stay-home-logo.jpg" class="w-24 h-24 mb-12 md:mx-16" />
      </div>
    </div>
  </div>
</template>

<script>
import { categories, assessments, choices } from "../data/assessment-whoqol";
import { notification } from "ant-design-vue";
import { std } from "mathjs";
import axios from "axios";

import VueTinySlider from "vue-tiny-slider";
import YanProgress from "yan-progress";

export default {
  components: {
    "tiny-slider": VueTinySlider,
  },
  mounted() {
    window.onbeforeunload = function () {
      return "คุณต้องการออกจากแบบสอบถามหรือไม่";
    };
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  data() {
    return {
      categories,
      assessments,
      choices,
      answers: [],
      progress: 0,
      finish: false,
    };
  },
  methods: {
    std,
    async submit() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
      });

      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/me/whoqol-assessment`,
          headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
          data: {
            finalResult: this.finalResult,
            rawFinalResult: JSON.stringify(this.rawFinalResult),
            rawCategoryWithAnswers: JSON.stringify(this.categoriesWithAnswers),
            rawAnswers: JSON.stringify(this.answersWithStats),
            average: this.average,
            standardDeviation: this.standardDeviation,
          },
        });

        loader.hide();

        this.$notify({
          type: "success",
          group: "foo",
          title: "บันทึกผลแบบประเมินแล้ว",
          text: "ข้อมูลของท่านจะถูกบันทึกในฐานข้อมูลและสามารถเข้าดูย้อนหลังได้",
        });

        const { id } = response.data;

        this.$router.push(`/assessment-whoqol/${id}`);
      } catch (error) {
        console.log(error);

        loader.hide();

        this.$notify({
          type: "error",
          group: "foo",
          title: "บันทึกไม่สำเร็จ",
          text: "ลองใหม่อีกครั้ง",
        });
      }

      // this.$router.replace("/assessments");
    },
    next(assessment, choice) {
      this.$refs.assessmentSlider.slider.goTo("next");

      const point =
        assessment.effect === "negative" ? Math.abs(choice.point - 6) : choice.point;

      this.answers.push({
        assessment,
        choice: { name: choice.name, point: point },
      });

      this.progress += 100 / 26;

      if (this.isFinish(assessment.index)) {
        this.submit();
      }
    },
    back() {
      this.$refs.assessmentSlider.slider.goTo("prev");

      this.progress -= 100 / 26;
    },
    isFinish(index) {
      return index == assessments.length;
    },
    reset() {
      location.reload();
    },
  },
  computed: {
    categoriesWithAnswers() {
      let withAnswers = this.categories
        .map((category) => {
          const answers = this.answers.filter((answer) =>
            category.indexes.includes(answer.assessment.index)
          );

          return { ...category, answers };
        })
        .map((category) => {
          const totalPoint = category.answers.reduce(
            (total, answer) => answer.choice.point + total,
            0
          );

          const result = category.criterias.find(
            (criteria) => totalPoint >= criteria.point
          );

          return { ...category, result, totalPoint };
        });

      const overviewTotalScore = withAnswers
        .filter((category) => category.key == "overview")
        .reduce((total, category) => category.totalPoint + total, 0);

      return withAnswers.map((category) => {
        const ratioFromTotalScore = (
          (category.totalPoint / overviewTotalScore) *
          100
        ).toFixed(2);

        return { ...category, ratioFromTotalScore };
      });
    },
    answersWithStats() {
      return this.answers.map((answer) => {
        const ratioFromTotalScore = (
          (answer.choice.point / this.totalScore) *
          100
        ).toFixed(2);

        return { ...answer, ratioFromTotalScore };
      });
    },
    totalScore() {
      return this.categoriesWithAnswers
        .filter((category) => category.key == "overview")
        .reduce((total, category) => category.totalPoint + total, 0);
    },
    categoryTotalScores() {
      return this.categoriesWithAnswers.map((category) => category.totalPoint);
    },
    rawFinalResult() {
      return this.categoriesWithAnswers.find((category) => category.key == "overview");
    },
    finalResult() {
      return this.rawFinalResult.result.name;
    },
    average() {
      return (this.totalScore / this.categoryTotalScores.length).toFixed(2);
    },
    standardDeviation() {
      const scores = this.answers.map((answer) => answer.choice.point);

      return std(scores).toFixed(2);
    },

  
  },
};
</script>

<style>
@import "../assets/tiny-slider.css";

.y-progress_bar {
  background-color: #9e76b4 !important;
}
</style>
